/**
 * Desi Firms Design System - Token Exports
 */

// Import all tokens first
import { colors, gradients } from './colors';
import {
  fontFamilies,
  fontSizes,
  fontWeights,
  lineHeights,
  letterSpacings,
  textStyles,
} from './typography';
import { spacing, componentSpacing, radii } from './spacing';
import { shadows, elevation, zIndices } from './shadows';
import { breakpoints, breakpointValues, media, containerWidths, gridColumns } from './breakpoints';
import { durations, easings, transitions, keyframes } from './animations';

// Re-export individual tokens
export { colors, gradients } from './colors';
export {
  fontFamilies,
  fontSizes,
  fontWeights,
  lineHeights,
  letterSpacings,
  textStyles,
} from './typography';
export { spacing, componentSpacing, radii } from './spacing';
export { shadows, elevation, zIndices } from './shadows';
export { breakpoints, breakpointValues, media, containerWidths, gridColumns } from './breakpoints';
export { durations, easings, transitions, keyframes } from './animations';

// Combined theme object for ThemeProvider
export const theme = {
  colors,
  gradients,
  fontFamilies,
  fontSizes,
  fontWeights,
  lineHeights,
  letterSpacings,
  textStyles,
  spacing,
  componentSpacing,
  radii,
  shadows,
  elevation,
  zIndices,
  breakpoints,
  breakpointValues,
  media,
  containerWidths,
  gridColumns,
  durations,
  easings,
  transitions,
  keyframes,
};

export default theme;
